// extracted by mini-css-extract-plugin
module.exports = {"tagCount":"articleDetails_tagCount__LbnCa"};